export const API_KEY = 'appid=634b0d67ec10e6b80374dfefaba2459c';
export const URL = 'https://api.openweathermap.org/data/2.5/weather';
